import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { config } from 'angular/utils/config';

class NetworkPointDetailsTradeProposalsCtrl implements ng.IController {
    public networkPointId: number;
    public uiLoadingTradeProposals: boolean = true;
    public tradeProposals: any = [];
    public appBaseUrl: string = config.appBaseUrl;

    public paginator = {
        identificationName: 'tradeProposals',
        itemsPerPage: 10,
        start: 0
    };

    public proposalType: string = 'PROPOSAL_TO_SELL';

    constructor(
        private TradeProposals,
        private errorHandler: ErrorHandler,
        public DATES
    ) {}

    $onInit(): void {
        this.getTradeProposals();
    }

    public getTradeProposals() {
        this.uiLoadingTradeProposals = true;

        let param = {
            proposalType: this.proposalType,
            networkPoint: this.networkPointId,
            pageSize: this.paginator.itemsPerPage,
            start: this.paginator.start
        };

        this.TradeProposals.page(
            param,
            (res) => {
                angular.forEach(res.data, (item) => {
                    item.hasRespond = item.actions.indexOf('RESPOND') > -1;
                });
                this.uiLoadingTradeProposals = false;
                this.tradeProposals = res;
            },
            this.errorHandler
        );
    }

    public getOffersProposals() {
        this.proposalType = 'PROPOSAL_TO_SELL';
        this.getTradeProposals();
    }

    public getRequestProposals() {
        this.proposalType = 'PROPOSAL_TO_BUY';
        this.getTradeProposals();
    }

    public changePage(newPageNumber) {
        let newPaginatorStart: number =
            (newPageNumber - 1) * this.paginator.itemsPerPage;
        if (newPaginatorStart !== this.paginator.start) {
            this.paginator.start = newPaginatorStart;
            this.getTradeProposals();
        }
    }
}

angular.module('app').component('pkpNetworkPointDetailsTradeProposals', {
    controller: NetworkPointDetailsTradeProposalsCtrl,
    template:
        require('app/network-point/network-point-details-trade-proposals.component.html'),
    bindings: {
        networkPointId: '<'
    }
});
